function loginEvent() {
  const loginLink = document.querySelector('.gtm_login');
  const customer = getCustomer();
  const isUserLoggedIn = localStorage.getItem('loginEvent');

  if (isUserLoggedIn) {
    handleUserLoginEvent(customer);
    localStorage.removeItem('loginEvent');
  }

  if (loginLink) {
    loginLink.addEventListener('click', () => {
      localStorage.setItem('loginEvent', true);
    });
  }
}

function getCustomer() {
  return document.querySelector('#customer-id').value || null;
}

function handleUserLoginEvent(customer) {
  if (customer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'userLogin',
      'method': 'login',
      'userId': customer 
    });
  }
}

loginEvent();